import React from 'react';
import { Row, Col, Card } from 'react-bootstrap';
import PropTypes from 'prop-types';

const MetricCard = ({ title, value, unit, color }) => (
	<Card className='shadow-sm mb-3 card-border'>
		<Card.Body className='text-center py-3'>
			<Card.Text className='text-muted mb-1' style={{ fontSize: '0.85rem' }}>{title}</Card.Text>
			<h3 style={{ color: color || '#333', marginBottom: 0 }}>
				{typeof value === 'number' ? value.toLocaleString('es-MX', { maximumFractionDigits: 2 }) : value || '—'}
			</h3>
			{unit && <small className='text-muted'>{unit}</small>}
		</Card.Body>
	</Card>
);

const StatsPerformanceCards = ({ performance }) => {
	if (!performance || Object.keys(performance).length === 0) {
		return <p className='text-center text-muted mt-3'>No performance data available</p>;
	}

	return (
		<Row className='mt-3'>
			<Col xs={6} md={3}>
				<MetricCard title='Total Jobs' value={performance.total_jobs} color='#0d6efd' />
			</Col>
			<Col xs={6} md={3}>
				<MetricCard title='Success Rate' value={performance.success_rate} unit='%' color='#198754' />
			</Col>
			<Col xs={6} md={3}>
				<MetricCard title='Error Rate' value={performance.error_rate} unit='%' color='#dc3545' />
			</Col>
			<Col xs={6} md={3}>
				<MetricCard title='Avg Process Time' value={performance.avg_process_time} unit='ms' color='#6c757d' />
			</Col>
		</Row>
	);
}

StatsPerformanceCards.propTypes = {
	performance: PropTypes.object
}

export default StatsPerformanceCards;
